import type { InboxFilters } from '@/features/inbox/hooks/useInboxFilters';

/**
 * Query key factory for consistent, stable keys across the app
 */
export const queryKeys = {
  conversations: {
    all: ['conversations'] as const,
    list: (filters: InboxFilters) => ['conversations', 'list', filters] as const,
  },
  messages: {
    all: ['messages'] as const,
    conversation: (conversationId: string) => ['messages', conversationId] as const,
  },
} as const;
